import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  TWO_FACTOR_REQUIRED,
  TWO_FACTOR_CANCEL,
  TWO_FACTOR_VERIFY,
  TWO_FACTOR_VERIFY_SUCCESS,
  TWO_FACTOR_VERIFY_ERROR,
  TWO_FACTOR_RESEND,
  TWO_FACTOR_RESEND_SUCCESS,
  TWO_FACTOR_RESEND_ERROR,
} from './actionTypes';

const initialState = {
  error: null,
  loading: false,

  twoFactor: {
    required: false,

    // dados para verify/resend
    email: null,
    server: '',
    challengeId: null,

    // UX
    maskedEmail: null,
    expiresIn: 0,
    codeLength: 6,

    // estados do modal
    loading: false, // validando código
    error: null,

    resendLoading: false,
    resendError: null,
  },
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        twoFactor: { ...initialState.twoFactor }, // limpa modal se logou
      };

    case API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case TWO_FACTOR_REQUIRED:
      return {
        ...state,
        loading: false,
        error: null,
        twoFactor: {
          ...state.twoFactor,
          required: true,
          email: action.payload.email,
          server: action.payload.server || '',
          challengeId: action.payload.challengeId,
          maskedEmail: action.payload.maskedEmail,
          expiresIn: action.payload.expiresIn,
          codeLength: Number(action.payload.codeLength) || 6,
          loading: false,
          error: null,
          resendLoading: false,
          resendError: null,
        },
      };

    case TWO_FACTOR_CANCEL:
      return {
        ...state,
        twoFactor: { ...initialState.twoFactor },
      };

    case TWO_FACTOR_VERIFY:
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          loading: true,
          error: null,
        },
      };

    case TWO_FACTOR_VERIFY_SUCCESS:
      return {
        ...state,
        twoFactor: { ...initialState.twoFactor },
      };

    case TWO_FACTOR_VERIFY_ERROR:
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          loading: false,
          error: action.payload,
        },
      };

    case TWO_FACTOR_RESEND:
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          resendLoading: true,
          resendError: null,
        },
      };

    case TWO_FACTOR_RESEND_SUCCESS:
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          resendLoading: false,
          resendError: null,
        },
      };

    case TWO_FACTOR_RESEND_ERROR:
      return {
        ...state,
        twoFactor: {
          ...state.twoFactor,
          resendLoading: false,
          resendError: action.payload,
        },
      };

    case LOGOUT_USER:
      return state;

    case LOGOUT_USER_SUCCESS:
      return { ...initialState };

    default:
      return state;
  }
};

export default login;
